<template>
  <div class="section modal">
    <div class="modal-header">
      <div class="model-header-title"><h3>Text preview</h3></div>
      <span class="modal-close">
        <i class="icon icon-cancel-circled" @click="onClose" />
      </span>
    </div>
    <div class="modal-body">
      <div class="modal-body-wrapper">
        <pre>{{ message() }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailTextPreview',
  props: {
    onClose: Function
  },

  data: () => {
    return {
      text: '',
      loading: false
    }
  },

  methods: {
    message() {
      if (this.loading) {
        return 'LOADING'
      } else {
        return this.text
      }
    }
  }
}
</script>

<style scoped>
.section {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  z-index: 1000000;
  display: block;
  position: relative;
  background-color: #fff;
}
.modal-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  zoom: 1;
  padding: 10px 16px 10px 20px;
  border-bottom: 1px solid #e5e5e5;
}
.model-header-title h3 {
  color: #505659;
  font-size: 15px;
  margin: 0;
  padding: 0;
  line-height: 38px;
  font-weight: 700;
  float: left;
}
.modal-close {
  float: right;
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  line-height: 33px;
  color: #979797;
  font-size: 23px;
  font-weight: 700;
  cursor: pointer;
}
.modal-close i {
  color: #505659;
}
.modal-body {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 25px;
  background-color: #f4f4f4;
  overflow: auto;
}
.modal-body-wrapper {
  border: 1px solid #c1c1c1;
  background-color: #fff;
  padding: 30px;
  max-width: 500px;
  margin: 0 auto;
}
pre {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/common/components/email/EmailTextPreview.vue